/* eslint-disable @nx/enforce-module-boundaries */
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { FormControl, FormLabel } from '@mybridge/ui/form-control';
import { HStack } from '@mybridge/ui/layout';
import { Select } from '@mybridge/ui/select';
import moment from 'moment';
import { forwardRef, useEffect, useMemo, useState } from 'react';

export const DateSelect = forwardRef(
  (
    {
      value,
      onChange,
      offset = 0,
      asElement = false,
      daySelectVisible = false,
      yearsCount = 50,
      monthOffset = 0,
      minDate,
      ...props
    },
    ref
  ) => {
    const [day, setDay] = useState(value?.day ?? 1);
    const [month, setMonth] = useState(
      value?.month ?? moment()?.get('month') + 1
    );
    const [year, setYear] = useState(value?.year ?? moment()?.get('year'));
    const { t } = useTranslator();
    const {formatNumber}=useNumberFormatter();
    // const yearOptions = useMemo(() => {
    //   const year = moment().year() - offset;
    //   return Array.from(Array(yearsCount)).map((_, ind) => (
    //     <option key={ind} value={year - ind}>
    //       {year - ind}
    //     </option>
    //   ));
    // }, []);
    // const monthOptions = useMemo(() => {
    //   return Array.from(Array(12)).map((_, ind) => (
    //     <option key={ind} value={ind + 1}>
    //       {moment()
    //         .set('month', ind + monthOffset)
    //         .format('MMM')}
    //     </option>
    //   ));
    // }, [yearOptions, year]);

    const yearOptions = useMemo(() => {
      const currentYear = moment().year() - offset;
      const startYear = minDate ? minDate.year : null;
      
      return Array.from(Array(yearsCount)).map((_, ind) => {
        const yearValue = currentYear - ind;
        
        // If minDate is provided and this year is before the minimum year, skip it
        if (startYear && yearValue < startYear) {
          return null;
        }
        
        return (
          <option key={ind} value={yearValue}>
            {formatNumber(yearValue)}
          </option>
        );
      }).filter(Boolean); // Remove null values
    }, [offset, yearsCount, minDate]);

    const monthOptions = useMemo(() => {
      return Array.from(Array(12)).map((_, ind) => {
        const monthValue = ind + 1;
        
        // If minDate is provided and current year equals min year, 
        // only show months >= minDate month
        if (minDate && year === minDate.year && monthValue < minDate.month) {
          return null;
        }
        
        return (
          <option key={ind} value={monthValue}>
            {moment()
              .set('month', ind + monthOffset)
              .format('MMM')}
          </option>
        );
      }).filter(Boolean); // Remove null values
    }, [year, minDate, monthOffset]);

    const dayOptions = useMemo(() => {
      if (!year || !month) {
        return <></>;
      }
      return Array.from(
        Array(
          moment()
            .set('y', year)
            .set('M', month - 1)
            .daysInMonth()
        )
      ).map((_, ind) => (
        <option key={ind} value={ind + 1}>
          {ind + 1}
        </option>
      ));
    }, [yearOptions, monthOptions, month, year]);

    const onChange_ = () => {
      if (asElement) {
        const obj = { target: { value: { day, month, year } } };
        onChange?.(obj);
      } else {
        onChange?.({ day, month, year });
      }
    };
    useEffect(() => {
      onChange_?.();
    }, [day, month, year]);

    return (
      <HStack {...props}>
        <FormControl {...props}>
          {props.variant !== 'floating' && <FormLabel>{t('profileExperience.month') || "Month"}</FormLabel>}
          <Select
            value={month}
            onChange={(e) => setMonth(parseInt('' + e.target.value))}
            variant={props.variant === 'floating' ? 'whiteInput' : ''}
          >
            {monthOptions}
          </Select>
          {props.variant === 'floating' && <FormLabel>{t('profileExperience.month') || "Month"}</FormLabel>}
        </FormControl>

        {daySelectVisible ? (
          <FormControl {...props}>
            {props.variant !== 'floating' && <FormLabel>{t('profileExperience.day') || "Day"}</FormLabel>}
            <Select
              value={day}
              onChange={(e) => setDay(parseInt('' + e.target.value))}
              variant={props.variant === 'floating' ? 'whiteInput' : ''}
            >
              {dayOptions}
            </Select>
            {props.variant === 'floating' && <FormLabel>{t('profileExperience.day') || "Day"}</FormLabel>}
          </FormControl>
        ) : (
          ''
        )}
        <FormControl {...props}>
        {props.variant !== 'floating' && <FormLabel>{t('profileExperience.year') || "Year"}</FormLabel>}
          <Select
            value={year}
            onChange={(e) => setYear(parseInt('' + e.target.value))}
            variant={props.variant === 'floating' ? 'whiteInput' : ''}
          >
            {yearOptions}
          </Select>
          {props.variant === 'floating' && <FormLabel>{t('profileExperience.year') || "Year"}</FormLabel>}
        </FormControl>
      </HStack>
    );
  }
);
